"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveI18n = exports.getI18nFirstSeparator = void 0;
var i18next_1 = __importDefault(require("i18next"));
var getI18nFirstSeparator = function (systemType) {
    return systemType === 'mobile' ? '.' : ':';
};
exports.getI18nFirstSeparator = getI18nFirstSeparator;
/**
 * Resolves an I18n descriptor to a display string.
 *
 * `i18n.t()` is typed to return `string`, but the bare i18next default instance
 * returns `undefined` when `init()` was never called. web-admin and web-food-ops
 * intentionally ship without an i18next runtime (they mount `TranslationProvider`
 * with no instance and rely on fallbacks), so calling `t()` there yields
 * `undefined` and renders an unlabelled, invisible string.
 *
 * Coalescing to `fallback` keeps those apps on their English defaults while
 * preserving real translations wherever i18next is initialised.
 */
var resolveI18n = function (_a) {
    var _b;
    var key = _a.key, fallback = _a.fallback, params = _a.params;
    return (_b = i18next_1.default.t(key, fallback, params)) !== null && _b !== void 0 ? _b : fallback;
};
exports.resolveI18n = resolveI18n;
